const headerLinks = [
  { name: 'Live shows', url: '#' },
  { name: 'Streams', url: '#' },
  { name: 'Movies', url: '#' },
  { name: 'Plays', url: '#' },
  { name: 'Events', url: '#' },
  { name: 'Sports', url: '#' },
  { name: 'Activites', url: '#' },
];

export default headerLinks;
